export const PRODUCT_REGION_CLICK = 'productRegionClick';
export const PRODUCT_REGION_CLICK_WITH_SKU = 'productRegionsWithSku';
export const PRODUCT_REGION_CLICK_EXTERNAL_LINK = 'productRegionExternalLinkClick';
export const PRODUCT_REGION_CLICK_IN_BLOCK_VIDEO = 'productRegionInBlockVideoClick';
export const PRODUCT_REGION_CLICK_VIDEO = 'productRegionVideoClick';

/**
 * The currently clicked product region contains a valid product sku
 * @type {string}
 */
export const PRODUCT_REGION_CLICK_VALID = 'productRegionClickValid';
